type StreamTextOptions = {
  text: string;
  element: HTMLElement;
  intervalMs?: number;
};

const streamText = ({ text, element, intervalMs = 15 }: StreamTextOptions): Promise<void> => {
  let count = 0;

  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (count >= text.length) {
        clearInterval(interval);

        resolve();
      }

      element.innerHTML = text.slice(0, count);
      count += 1;
    }, intervalMs);
  });
};

export default streamText;
